import { getRandomIntInclusive } from '@application/utils';
import { CardItemContainer, CardItemLitter } from '@presentation/components';
import type { FC } from 'react';
import * as RootStyled from '../../styled';

export const PageSkeleton: FC = () => {
  return (
    <CardItemContainer>
      {Array(getRandomIntInclusive(1, 3))
        .fill(undefined)
        .map((_, index) => (
          <RootStyled.CardItemWrapper key={index}>
            <CardItemLitter
              style={{ height: 327.5 }}
              key={index}
              loading
              breed=""
              price=""
              location=""
            />
          </RootStyled.CardItemWrapper>
        ))}
    </CardItemContainer>
  );
};
